import { render, staticRenderFns } from "./FormWorkspace.vue?vue&type=template&id=30e09058"
import script from "./FormWorkspace.vue?vue&type=script&lang=js"
export * from "./FormWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports